import { render, staticRenderFns } from "./SingleHelp.vue?vue&type=template&id=4f604557"
import script from "./SingleHelp.vue?vue&type=script&lang=js"
export * from "./SingleHelp.vue?vue&type=script&lang=js"
import style0 from "./SingleHelp.vue?vue&type=style&index=0&id=4f604557&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports